import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { ExpandableBlocks, ContentBlock } from 'components/ContentBlock'
import { Form, Text, TextArea, Select, Checkbox, Number as NumberInput } from 'components/forms'
import NewRecord from '../NewRecord'
import PhoneNumberField from './PhoneNumbersField'
import globalStyles from 'style/app.module.scss'
import { languageOptions } from 'sections/options/sections/GeneralSettings/GeneralSettingsHandler'
import { loadAppConstants } from 'gql/query'
import listProducts from '../../gql/listLoadProducts'
import Divider from 'components/Divider'
import { useQuery } from 'components/graphql'
import get from 'lodash/get'

const MainParams = ({ formData, mutations: { updateItem }, newRecord }) => {
	const {
		loyaltyProdItemId,
		loyaltyProdItemIdOp2,
		loyaltyProdItemIdOp3,
		loyaltyProdItemIdOp4,
		loyaltyProdItemIdOp5
	} = formData?.parameters || {}
	const selectedCardOptions = [
		loyaltyProdItemId,
		loyaltyProdItemIdOp2,
		loyaltyProdItemIdOp3,
		loyaltyProdItemIdOp4,
		loyaltyProdItemIdOp5
	]
	const [t, i18n] = useTranslation()
	const { data: loyaltyCardOptionsData } = useQuery(listProducts, {
		variables: { filter: { checkOutCommandId: '230' } }
	})
	const loyaltyCardItems = get(loyaltyCardOptionsData, 'listProducts.items', [])
	const loyaltyCardOptionsField = [
		{ label: t('options_section.fields.load_loyalty_card_product'), field: 'parameters.loyaltyProdItemId' },
		{ field: 'parameters.loyaltyProdItemIdOp2' },
		{ field: 'parameters.loyaltyProdItemIdOp3' },
		{ field: 'parameters.loyaltyProdItemIdOp4' },
		{ field: 'parameters.loyaltyProdItemIdOp5' }
	]
	const loyaltyCardOptionsItems = loyaltyCardItems?.map(({ id, name }) => ({ value: id, label: name, disabled: selectedCardOptions.includes(id) }))

	if(newRecord) {
		return <NewRecord/>
	}

	return(
		<>
			<ExpandableBlocks>
				<ContentBlock alwaysExpanded>
					<Form
						smartSubmit
						initialValues={formData}
						onSubmit={updateItem}
						className={globalStyles['flex-cols']}
					>
						<Row>
							<Col xs>
								{/*<Text field='Anrede' label='Anrede' placeholder='Anrede eintragen'/>*/}
								<Text field='parameters.companyName' label={t('options_section.fields.company_name')} placeholder='Firmenname eintragen'/>
								<TextArea field='parameters.additionName' label={t('options_section.fields.additive')} placeholder='Zusatz eintragen'/>
								<Text field='parameters.street' label={t('options_section.fields.street')} placeholder='Strasse eintragen'/>
								<Text field='parameters.postCode' label={t('options_section.fields.postcode')} inline style={{ width: 100 }}/>
								<Text field='parameters.city' inline style={{ width: 180 }}/>
								<Text field='parameters.phone' label={t('options_section.fields.telephones')} placeholder='Telefone eintragen'/>
								{/*<Text field='Fax' label='Fax' placeholder='Fax eintragen'/>*/}
								<Text field='parameters.vatNumber' label={t('options_section.fields.vat_number')} />
								{/*<Text field='oko' label='Oko Krt.-Nr.'/>*/}
								<TextArea field='parameters.optional1' label={t('options_section.fields.optional1')} />
								<TextArea field='parameters.optional2' label={t('options_section.fields.optional2')} />
								<Select
									field='parameters.country'
									label={t('options_section.fields.country')}
									remoteOptions={{
										query: loadAppConstants,
										variables: { type: 19, language: i18n.language }
									}}
								/>
								<Select field='parameters.language' label={t('options_section.fields.language')} options={languageOptions}/>
							</Col>
							<Col xs>
								{/*<Text field='Optional 1' label='Optional 1' placeholder='Optional eintragen'/>
									<Text field='Optional 2' label='Optional 2' placeholder='Optional eintragen'/>*/}
								<TextArea field='parameters.advertisingText' label={t('options_section.fields.ad_text')} />
								<PhoneNumberField field='parameters.smsNotificationPhoneNumbers'/>
								{/*<Select field='Landereinstellung' label='Landereinstellung'/>
									<Select field='Wahrung' label='Wahrung'/>
									<Select field='Konzept' label='Konzept'/>*/}
							</Col>
						</Row>
					</Form>
				</ContentBlock>

				<ContentBlock label={t('options_section.strings.printing')}>
					<Form
						smartSubmit
						initialValues={formData}
						onSubmit={updateItem}
						className={globalStyles['flex-cols']}
					>
						<NumberInput
							field='parameters.printer.printBillFromAmount'
							label={t('options_section.fields.only_if_greater')}
							precision={2}
							withControls={false}
							shrink
						/>
						<Checkbox field='parameters.printer.autoPrintBills' label={t('options_section.fields.auto_receipt_always')} />
					</Form>
				</ContentBlock>

				<ContentBlock label={t('options_section.strings.loyalty_cards')}>
					<Form
						smartSubmit
						initialValues={formData}
						onSubmit={updateItem}
						className={globalStyles['flex-cols']}
					>
						<Row>
							<Col xs>
								<Checkbox field='parameters.printer.notPrintRFIDBills' label={t('options_section.fields.no_auto_print_receipt_rfid')} />
							</Col>
							<Col xs>
								<Select
									field='parameters.loginMode'
									label={t('options_section.fields.smartcheckout_login_mode')}
									options={[
										{ value: 0, label: t('options_section.strings.with_rfid') },
										{ value: 1, label: t('options_section.strings.without_rfid') },
										{ value: 2, label: t('options_section.strings.multi_users') },
										{ value: 3, label: t('options_section.strings.multi_users_rfid') }
									]}
								/>
							</Col>
						</Row>
						<Divider />
						<Row>
							<Col xs>
								{loyaltyCardOptionsField.map((item, idx) => (
									<Select
										key={idx}
										label={item.label}
										field={item.field}
										isClearable
										options={loyaltyCardOptionsItems}
										isOptionDisabled={(option) => option.disabled}
									/>
								))}
							</Col>
							<Col xs>
								<Select
									label={t('options_section.fields.load_employee_card_product')}
									field='parameters.employeeLoyaltyProductId'
									valueField='id'
									labelField='name'
									isClearable
									isSearchable
									options={loyaltyCardOptionsItems}
								/>
							</Col>
						</Row>
					</Form>
				</ContentBlock>
			</ExpandableBlocks>
		</>
	)
}

export default MainParams
